<template>
    <div
        class="inline-flex items-center flex-shrink-0 p-4 text-sm"
        :class="[alignmentClass, className, {
            'overflow-hidden': truncate,
        }]"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            align: {
                type: String,
                default: 'left',
            },
            truncate: {
                type: Boolean,
                default: true,
            },
            className: {
                type: String,
                default: '',
            },
        },

        computed: {
            alignmentClass() {
                if (this.align === 'center') {
                    return 'justify-center';
                }

                if (this.align === 'right') {
                    return 'justify-end';
                }

                return 'justify-start';
            },
        },
    };
</script>
